import { render, staticRenderFns } from "./v-catalog.vue?vue&type=template&id=7a5ad615&"
import script from "./v-catalog.vue?vue&type=script&lang=js&"
export * from "./v-catalog.vue?vue&type=script&lang=js&"
import style0 from "./v-catalog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports